import { Card, Accordion } from 'react-bootstrap'
import UnitSpinButton from 'UnitSpinButton'
import SpinButton from 'SpinButton';
import { GroupSelect } from 'GroupSelect';
import { useSettings } from 'Settings'

const types = [
	{ value : 'capacitor', label : 'Capacitor' },
	{ value : 'primary battery', label : 'Primary Battery' },
	{ value : 'secondary battery', label : 'Secondary Battery' },
]

const Storage = ({name}) => {
	const [settings] = useSettings()
	const current = settings['capacitors'][name]

	return (
		<Accordion.Item eventKey={name}>
			<Accordion.Header>{name.toUpperCase()}</Accordion.Header>
			<Accordion.Body>
				<GroupSelect
					name="Type"
					value={current['type'].value}
					options={types}
					onChange={(v) => current['type'].setValue(v.value)}
				/>
				<SpinButton
					unit="mAh"
					value={current['capacity'].value}
					name="Capacity"
					onChange={(e) => {
						current['capacity'].setValue(e.target.value)
					}}
					min="1"
					max="999"
					step="0.1"
					gstyle={{
						display: current['type'].value === 'capacitor' ? 'none' : 'block'
					}}
				/>
				<SpinButton
					unit="μF"
					value={current['capacitance'].value}
					name="Capacitance"
					onChange={(e) => {
						current['capacitance'].setValue(e.target.value)
					}}
					min="1"
					max="999"
					step="0.1"
					gstyle={{
						display: current['type'].value === 'capacitor' ? 'block' : 'none'
					}}
				/>
				<SpinButton
					unit="μA"
					value={current['self-discharge-current'].value}
					name="Self-Discharge-Current"
					onChange={(e) => {
						current['self-discharge-current'].setValue(e.target.value)
					}}
					min="0"
					max="999"
					step="0.1"
				/>
				<SpinButton
					unit="Ω"
					value={current['input-resistance'].value}
					name="Input-Resistance"
					onChange={(e) => {
						current['input-resistance'].setValue(e.target.value)
					}}
					min="0"
					max="999"
					step="0.1"
				/>
				<SpinButton
					unit="Ω"
					value={current['output-resistance'].value}
					name="Output-Resistance"
					onChange={(e) => {
						current['output-resistance'].setValue(e.target.value)
					}}
					min="0"
					max="999"
					step="0.1"
				/>
			</Accordion.Body>
		</Accordion.Item>
	)
}

export default function Capacitors() {
	const [settings] = useSettings()
	const capacitors = settings['capacitors']

	const units = [
		{ value : 3, label : "nF"},
		{ value : 2, label : "μF"},
		{ value : 1, label : "mF"},
		{ value : 0, label : "F"}
	]

	return (
		<Card className="mb-3">
			<Card.Body>
				<Card.Title>Capacitors</Card.Title>
				<UnitSpinButton
					unit={capacitors['c_hrv']['unit'].value}
					value={capacitors['c_hrv']['value'].value}
					name="C_HRV"
					options={units}
					onChange={(e) => {
						capacitors['c_hrv']['unit'].setValue(e.target.value.unit)
						capacitors['c_hrv']['value'].setValue(e.target.value.value)
					}}
					min="1"
					max="999"
					step="0.1"
				/>
				<UnitSpinButton
					unit={capacitors['c_reg']['unit'].value}
					value={capacitors['c_reg']['value'].value}
					name="C_REG"
					options={units}
					onChange={(e) => {
						capacitors['c_reg']['unit'].setValue(e.target.value.unit)
						capacitors['c_reg']['value'].setValue(e.target.value.value)
					}}
					min="1"
					max="999"
					step="0.1"
					disabled
				/>
				<Accordion>
					<Storage name="sts" />
					<Storage name="lts" />
				</Accordion>
			</Card.Body>
		</Card>
	)
}
